/**
 * Hook to handle back button press.
 * @param callback Action to run when back button is pressed. Return true to prevent default behavior.
 */
export const useBackHandler = (callback: () => boolean) => {};
